import { render, staticRenderFns } from "./EndorsementSelectedPolicy.vue?vue&type=template&id=10c1c2ea"
import script from "./EndorsementSelectedPolicy.vue?vue&type=script&lang=js"
export * from "./EndorsementSelectedPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports